(() => {
  const mobile = matchMedia('(max-width: 768px)');
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const heroes = new Map();
  function initHero(root) {
    if (heroes.has(root)) return;
    const slides = [...root.querySelectorAll('.bigsw .swiper-slide')];
    const products = [...root.querySelectorAll('.hero-hot-product')];
    const pagination = root.querySelector('.swiper-pagination');
    let index = 0, productIndex = 0, timer, productTimer, paused = false;
    function show(next) {
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === index);
        slide.inert = i !== index;
        slide.setAttribute('aria-hidden', String(i !== index));
      });
      pagination?.querySelectorAll('button').forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
        dot.setAttribute('aria-current', String(i === index));
      });
    }
    function stop() { clearInterval(timer); clearInterval(productTimer); }
    function start() {
      stop();
      if (paused || reducedMotion.matches || document.hidden) return;
      if (slides.length > 1) timer = setInterval(() => show(index + 1), Number(root.dataset.heroSpeed) || 6000);
      if (products.length > 1) productTimer = setInterval(() => {
        productIndex = (productIndex + 1) % products.length;
        products.forEach((product, i) => { product.classList.toggle('is-active', i === productIndex); product.inert = i !== productIndex; });
      }, Number(root.dataset.productSpeed) || 4000);
    }
    if (pagination) {
      pagination.replaceChildren();
      if (slides.length > 1) slides.forEach((_, i) => {
        const button = document.createElement('button'); button.type = 'button';
        button.setAttribute('aria-label', `Show slide ${i + 1}`);
        button.addEventListener('click', () => { show(i); start(); });
        pagination.append(button);
      });
    }
    const enter = () => { paused = true; stop(); };
    const leave = () => { paused = false; start(); };
    const focusOut = event => { if (!root.contains(event.relatedTarget)) leave(); };
    root.addEventListener('mouseenter', enter); root.addEventListener('mouseleave', leave);
    root.addEventListener('focusin', enter); root.addEventListener('focusout', focusOut);
    document.addEventListener('visibilitychange', start);
    reducedMotion.addEventListener('change', start);
    heroes.set(root, () => {
      stop(); document.removeEventListener('visibilitychange', start); reducedMotion.removeEventListener('change', start);
      heroes.delete(root);
    });
    products.forEach((p,i) => {p.inert=i!==0;});
    if (slides.length) show(0);
    start();
  }
  function init(scope = document) {
    scope.querySelectorAll('.exact-hero').forEach(initHero);
    scope.querySelectorAll('.jovi-footer-toggle').forEach(button => {
      if (button.dataset.ready) return;
      button.dataset.ready = 'true';
      const links = document.getElementById(button.getAttribute('aria-controls'));
      if (!links) return;
      function set(open) {button.setAttribute('aria-expanded',String(open)); links.hidden=!open;}
      set(!mobile.matches);
      button.addEventListener('click', () => {if (mobile.matches) set(button.getAttribute('aria-expanded') !== 'true');});
      mobile.addEventListener('change', () => set(!mobile.matches));
    });
    scope.querySelectorAll('.mfc-header .menu .hasDown > a').forEach(link => {
      if (!link.hasAttribute('aria-expanded')) link.setAttribute('aria-expanded', 'false');
    });
    scope.querySelectorAll('[data-guide-search]').forEach(input => {input.placeholder = 'Search product or model';});
    scope.querySelectorAll('.mfc-col2__filters').forEach(drawer => {
      if (drawer.dataset.repairReady) return;
      drawer.dataset.repairReady='true';
      const section = drawer.closest('.shopify-section');
      const trigger = section?.querySelector('[data-filter-open]');
      function close() {
        section?.classList.remove('filters-open'); document.body.classList.remove('mfc-filter-lock');
        trigger?.setAttribute('aria-expanded','false'); trigger?.focus();
      }
      trigger?.setAttribute('aria-expanded', 'false');
      trigger?.addEventListener('click', () => {trigger.setAttribute('aria-expanded','true'); drawer.querySelector('[data-filter-close]')?.focus();});
      section?.querySelectorAll('[data-filter-close]').forEach(button => button.addEventListener('click',close));
      drawer.addEventListener('keydown', event => {
        if (innerWidth > 989) return;
        if (event.key === 'Escape') {event.preventDefault();close();}
        if (event.key !== 'Tab') return;
        const items=[...drawer.querySelectorAll('button:not([disabled]),input:not([disabled]),select,a[href],summary')].filter(el=>el.getClientRects().length);
        if (!items.length) return;
        const first=items[0],last=items.at(-1);
        if (event.shiftKey && document.activeElement===first) {event.preventDefault();last.focus();}
        else if (!event.shiftKey && document.activeElement===last) {event.preventDefault();first.focus();}
      });
      matchMedia('(min-width: 990px)').addEventListener('change', event => {if(event.matches){section?.classList.remove('filters-open');document.body.classList.remove('mfc-filter-lock');trigger?.setAttribute('aria-expanded','false');}});
    });
  }
  const chatRoots = new WeakMap();
  const chatLauncherCSS = ".activator{background:#E7C33A!important;background-image:none!important;color:#303030!important;box-sizing:border-box!important;align-items:center!important;justify-content:center!important;gap:8px!important;width:104px!important;min-width:104px!important;max-width:104px!important;height:44px!important;min-height:44px!important;padding:10px 12px!important;border-radius:8px!important;bottom:calc(16px + env(safe-area-inset-bottom))!important;right:16px!important}.activator__label{color:#303030!important;display:block!important;font-size:14px!important;line-height:20px!important;margin:0!important;white-space:nowrap!important}.activator__icon{color:#303030!important;width:20px!important;height:20px!important;margin:0!important;flex:none!important}.activator__icon svg{width:20px!important;height:20px!important}:host(:not([open])) .activator{display:flex!important}@media(max-width:749px){.activator{width:96px!important;min-width:96px!important;max-width:96px!important;right:12px!important;bottom:calc(12px + env(safe-area-inset-bottom))!important}}";
  function setupChat() {
    // The lazy agent runtime has its own shadow root after the first open.
    const visit = host => {
      const shadow = host.shadowRoot;
      if (!shadow) return;
      let sync = chatRoots.get(shadow);
      if (!sync) {
        sync = () => {
          let style = shadow.querySelector('#jovi-chat-mobile-style');
          if (!style) {
            style = document.createElement('style');
            style.id = 'jovi-chat-mobile-style';
            style.textContent = chatLauncherCSS;
            shadow.append(style);
          }
          const label = shadow.querySelector('.activator__label');
          if (label && label.textContent !== 'Chat') label.textContent = 'Chat';
          const activator = shadow.querySelector('.activator');
          if (activator && activator.getAttribute('aria-label') !== 'Chat') activator.setAttribute('aria-label', 'Chat');
          shadow.querySelectorAll('shopify-agent-runtime').forEach(visit);
        };
        chatRoots.set(shadow, sync);
        let pending = false;
        new MutationObserver(() => {
          if (pending || !host.isConnected) return;
          pending = true;
          queueMicrotask(() => { pending = false; if (host.isConnected) sync(); });
        }).observe(shadow, {childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class', 'style', 'hidden', 'aria-label']});
      }
      sync();
    };
    document.querySelectorAll('shopify-chat').forEach(visit);
  }
  function start() {
    init();setupChat();
    const syncOverlay = () => document.body.classList.toggle('jovi-overlay-open', Boolean(document.querySelector('facet-drawer[open],cart-drawer[open],search-drawer[open],quick-buy-drawer[open]')));
    let scheduled=false;
    new MutationObserver(records => {
      if (!records.some(r=>r.type==='childList'||r.attributeName==='open')) return;
      if(scheduled)return; scheduled=true;
      requestAnimationFrame(()=>{scheduled=false;setupChat();syncOverlay();});
    }).observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['open']});
    customElements.whenDefined('shopify-chat').then(setupChat);
    customElements.whenDefined('shopify-agent-runtime').then(setupChat);
    document.addEventListener('keydown', event => {
      if(event.key!=='Escape')return;
      if (document.body.classList.contains('mfc-filter-lock')) {
        const section = document.querySelector('.shopify-section.filters-open');
        section?.classList.remove('filters-open');document.body.classList.remove('mfc-filter-lock');
        const trigger=section?.querySelector('[data-filter-open]');trigger?.setAttribute('aria-expanded','false');trigger?.focus();
      }
      const header=document.querySelector('.mfc-header.open');
      if(header){header.classList.remove('open');document.documentElement.classList.remove('exact-menu-open');const toggle=header.querySelector('.navbar-toggle');toggle?.setAttribute('aria-expanded','false');toggle?.focus();}
    });
  }
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded',start);else start();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('.exact-hero').forEach(root=>heroes.get(root)?.());
  });
})();
